/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */

import React, { useState } from 'react';
import { SideNavigation, ButtonIcons, BUTTON_TYPES } from '@tripian/react';
import { useHistory } from 'react-router';

import { USER_PROFILE as USER_PROFILE_PATH_TITLE, HOME as HOME_PATH_TITLE, CREATE_TRIP as CREATE_TRIP_PATH_TITLE, TRAVEL_COMPANIONS as TRAVEL_COMPANIONS_PATH_TITLE } from '../../constants/ROUTER_PATH_TITLE';

import './AppNav.scss';
import config from '../../config';
import LOCAL_STORAGE_KEYS from '../../constants/LOCAL_STORAGE_KEYS';
import TripianLogo from '../../assets/img/logo-large.png';
import TripianLogoIcon from '../../assets/img/tripian-icon-32.png';

import useAuth from '../../hooks/useAuth';
import useTrip from '../../hooks/useTrip';
import TripInfoHeader from './TripInfoHeader/TripInfoHeader';
import useUser from '../../hooks/useUser';

interface IAppNav {
  header?: string;
  tripInfoHeader?: boolean;
  tripAppMenu?: JSX.Element;
}

const AppNav: React.FC<IAppNav> = ({ header, tripInfoHeader = false, tripAppMenu }) => {
  const [show, setShow] = useState<boolean>(false);

  const { isLoggedIn, logout } = useAuth();
  const { user } = useUser();
  const { tripClear, tripReference } = useTrip();

  const history = useHistory();

  if (!isLoggedIn) return null;
  const userFullName = `${user?.first_name || ''} ${user?.last_name || ''}`;

  const sideNavigationMenuItems = [
    {
      header: 'TRIPS',
      title: 'My Trips',
      onClick: () => {
        history.push(HOME_PATH_TITLE.PATH);
      },
    },

    {
      header: 'TRIPS',
      title: 'Create New Trip',
      onClick: () => {
        history.push(CREATE_TRIP_PATH_TITLE.PATH);
      },
    },

    {
      header: 'USER',
      title: 'Profile',
      onClick: () => {
        history.push(USER_PROFILE_PATH_TITLE.PATH);
      },
    },

    {
      header: 'USER',
      title: 'Travel Companions',
      onClick: () => {
        history.push(TRAVEL_COMPANIONS_PATH_TITLE.PATH);
      },
    },

    {
      header: 'USER',
      title: 'Logout',
      onClick: () => {
        localStorage.removeItem(`${LOCAL_STORAGE_KEYS.TOKEN}-${config.name}`);
        logout();
        tripClear();
      },
    },
  ];

  const pageNav = (
    <>
      {header ? <h2 className="appnav-page-title">{header}</h2> : null}

      {tripInfoHeader ? <TripInfoHeader /> : null}

      {tripReference && tripAppMenu ? <div className="app-nav-icon-image-container">{tripAppMenu}</div> : null}
    </>
  );

  return (
    <>
      <header className="header headerFake">
        <div className="hcontainer" />
      </header>
      <header className="header fixed bshadow">
        <div className="hcontainer">
          {config.HIDE_SIDE_NAV ? null : (
            <div className="pl3" style={{ position: 'absolute' }}>
              <ButtonIcons.Bars
                type={BUTTON_TYPES.TEXT}
                onClick={() => {
                  setShow(true);
                }}
              />
            </div>
          )}
          <div className="logo">
            <img src={config.LOGO_PATH || TripianLogo} alt="logo" className="hide-s" />
            <img src={TripianLogoIcon} alt="logo" className="hide" />
          </div>
          {pageNav}
        </div>
      </header>
      {config.HIDE_SIDE_NAV ? null : (
        <SideNavigation
          title={userFullName}
          menuItems={sideNavigationMenuItems}
          open={show}
          closed={() => {
            setShow(false);
          }}
        />
      )}
    </>
  );
};

export default AppNav;
